// extracted by mini-css-extract-plugin
export default {"root":"ConfirmationDeactivationModal_root__v6ale","sub-header":"ConfirmationDeactivationModal_sub-header__pDE4l"};